module.exports = __webpack_public_path__ + "img/editIcon.223b2791.svg";